import React from 'react';

import Tooltip from '../../../builder-io/storyblocks-design-system/components/atoms/Tooltip/Tooltip';

// RFPC-1334: "100% human-made content" tag shown near the search results count for all
// users on all search pages when the `messaging_updates` experiment is in the `test`
// variant. Matches Figma node 1148:13416. Uses the `green-ai` design-system colors.
// RFPC-1371: dropped the info-icon link; the AI policy now surfaces as the design-system
// (Radix) tooltip on hover/focus, which also wires `aria-describedby` for assistive tech.
// Explicit line breaks match the Figma tooltip layout (node 1148:13416); rendered via
// `whitespace-pre-line`, which inherits to the title text. Assistive tech still reads it
// as one sentence.
const POLICY_TOOLTIP =
  'Everything in our library is\nhuman-made by our global\nnetwork of artists.';

function HumanMadeTag() {
  return (
    <Tooltip
      title={POLICY_TOOLTIP}
      className="text-center whitespace-pre-line px-6"
      maxWidth="xs"
      trigger={
        <div
          className="inline-flex items-center px-2 py-0.5 rounded-full text-sm bg-green-ai-100 text-green-ai-900"
          data-cy="humanMadeTag"
          tabIndex={0}
        >
          <span className="whitespace-nowrap">100% human-made content</span>
        </div>
      }
    />
  );
}

export default HumanMadeTag;
